"use strict";
let navButton = document.querySelector(".btn--menu");
let menuElement = document.querySelector(".logo-menu");
navButton.addEventListener("click", toggleNavigation);
function toggleNavigation(){
    if(document.body.hasAttribute("data-menu")){
        document.body.removeAttribute("data-menu");
        menuElement.setAttribute("src", "assets/images/burger-menu.svg");
    }else{
        document.body.setAttribute("data-menu", true);
        menuElement.setAttribute("src", "assets/images/croix.svg");
    }
}

var darkmode = document.querySelector(".btn--darkmode");
var imgElement = document.querySelector(".logo-darkmode");
darkmode.addEventListener("click", darkTheme);

if (typeof localStorage.mode === 'undefined'){
    localStorage.setItem("mode", "jour");
}

if(localStorage.getItem("mode") == "nuit"){
    document.body.classList.add("dark");
    imgElement.setAttribute("src", "assets/images/soleil.svg");
}

if(localStorage.getItem("mode") == "jour"){
    imgElement.setAttribute("src", "assets/images/lune.svg");
}

function darkTheme(){
    document.body.classList.toggle("dark");
    if(localStorage.getItem("mode") == "nuit"){
        imgElement.setAttribute("src", "assets/images/lune.svg");
        localStorage.setItem("mode", "jour");
    }else if(localStorage.getItem("mode") == "jour"){
        imgElement.setAttribute("src", "assets/images/soleil.svg");
        localStorage.setItem("mode", "nuit");
    }
}

let annee = new Date().getFullYear();
let date = document.querySelector(".date");
date.innerHTML = "© Copyright 2020 - "+(annee);